import {Injectable} from '@angular/core';
import {AlertController, ToastController} from '@ionic/angular';

import {AppConfig} from '../app.config';

@Injectable({
	providedIn: 'root'
})
export class AlertsService {

	constructor(private alertCtrl: AlertController, private toastCtrl: ToastController) {
	}

	async confirmationAlert(header, message, buttonTextConfirmation, buttonTextCancel: string = 'Annuler') {
		let result = null;
		const alert = await this.alertCtrl.create({
			buttons: [
				{
					text: buttonTextCancel,
					cssClass: 'button-alert-atmosphere background-white border-peacock-blue border-radius-4 text-style-13',
					handler: data => {
						result = false;
					}
				},
				{
					text: buttonTextConfirmation,
					cssClass: 'button-alert-atmosphere background-peacock-blue border-transparent border-radius-4 text-style-2',
					handler: data => {
						result = true;
					}
				}
			],
			backdropDismiss: false,
		});
		alert.cssClass = 'alert-atmosphere';
		if (header != null) {
			alert.header = header;
		}
		if (message != null) {
			alert.message = message;
		}
		await alert.present();
		await alert.onDidDismiss();
		return result;
	}

	async messageAlert(header, message) {
		const alert = await this.alertCtrl.create({
			buttons: [
				{
					text: 'OK',
					cssClass: 'button-alert-atmosphere background-peacock-blue border-transparent border-radius-4 text-style-2',
					handler: data => {
					}
				}
			],
			backdropDismiss: false,
		});
		alert.cssClass = 'alert-atmosphere';
		if (header != null) {
			alert.header = header;
		}
		if (message != null) {
			alert.message = message;
		}
		await alert.present();
		await alert.onDidDismiss();
	}

	async messageInput(header, message, value) {
		let result;
		const alert = await this.alertCtrl.create({
			buttons: [
				{
					text: 'Annuler',
					cssClass: 'button-alert-atmosphere background-white border-peacock-blue border-radius-4 text-style-13',
					handler: data => {
						result = null;
					}
				},
				{
					text: 'Valider',
					cssClass: 'button-alert-atmosphere background-peacock-blue border-transparent border-radius-4 text-style-2',
					handler: data => {
						result = data;
					}
				}
			],
			backdropDismiss: false,
			inputs: [
				{
					type: 'text',
					value
				}
			]
		});
		alert.cssClass = 'alert-atmosphere';
		if (header != null) {
			alert.header = header;
		}
		if (message != null) {
			alert.message = message;
		}
		await alert.present().then(() => {
			const firstInput: any = document.querySelector('ion-alert input');
			firstInput?.focus();
			return;
		});
		await alert.onDidDismiss();
		return result ? result[0] : null;
	}

	async messageToast(message) {
		const toast = await this.toastCtrl.create({
			message: message,
			duration: 3000,
			position: 'top',
			cssClass: 'toast-atmosphere toast-ok-atmosphere',
			buttons: [{
				side: 'end',
				role: 'close',
				icon: 'close'
			}]
		});
		await toast.present();
	}

	async errorAlert(header, message) {
		const alert = await this.alertCtrl.create({
			buttons: [
				{
					text: 'Fermer',
					cssClass: 'button-alert-atmosphere background-peacock-blue border-transparent border-radius-4 text-style-2',
					handler: data => {
					}
				}
			],
			backdropDismiss: false,
		});
		alert.cssClass = 'alert-atmosphere';
		if (header != null) {
			alert.header = header;
		}
		if (message != null) {
			alert.message = message;
		}
		await alert.present();
		const {data} = await alert.onDidDismiss();
	}

	async inputRadioAlert(header, message, buttonTextConfirmation, choices) {
		let result = null;
		const inputs = [];
		for (const i in choices) {
			inputs.push({
				label: choices[i].label,
				type: 'radio',
				value: choices[i].value,
				cssClass: ''
			})
		}
		const alert = await this.alertCtrl.create({
			inputs: inputs,
			buttons: [
				{
					text: 'Annuler',
					cssClass: 'button-alert-atmosphere background-white border-peacock-blue border-radius-4 text-style-13',
					handler: data => {
						result = {confirmed: false};
					}
				},
				{
					text: buttonTextConfirmation,
					cssClass: 'button-alert-atmosphere background-peacock-blue border-transparent border-radius-4 text-style-2',
					handler: data => {
						result = {confirmed: true, input: data != null ? data : null};
					}
				}
			],
			backdropDismiss: false,
		});
		alert.cssClass = 'alert-atmosphere';
		if (header != null) {
			alert.header = header;
		}
		if (message != null) {
			alert.message = message;
		}
		await alert.present().then(() => {
			const firstInput: any = document.querySelector('ion-alert input');
			firstInput?.focus();
			return;
		});
		await alert.onDidDismiss();
		return result;
	}

	getErrorMessage(error) {
		let errorMessage = 'Erreur';
		switch (error) {
			case 403:
			case 'bad-login':
				errorMessage = 'L\'identifiant ou le mot de passe est incorrect.';
				break;
			case 'cant-be-factured':
				errorMessage = 'La quantité facturée est supérieure au reste à facturer.';
				break;
			case 404:
				errorMessage = 'L\'action n\'est pas autorisée.';
				break;
			case 'NO_AVENANT':
				errorMessage = 'Pas d\'avenant pour cette convention';
				break;
			case 'PDF' :
				errorMessage = 'Erreur lors de la création du PDF. Merci de réessayer ultérieurement.';
				break;
			case 'EXCEL' :
				errorMessage = 'Erreur lors de la création du fichier Excel.';
				break;
			case 'WORD' :
				errorMessage = 'Erreur lors de la création du document Word.';
				break;
			case 500:
				errorMessage = 'Erreur interne';
				break;
			case 'FILE_TOO_LARGE' :
				errorMessage = 'Fichier trop volumineux (' + AppConfig.maxFileSize + ' Mo maximum par fichier)';
				break;
			case 'INDICE_NOT_AVAILABLE':
				errorMessage = 'La valeur d\'un ou plusieurs indice(s) n\'est pas encore disponible.';
				break;
			default :
				break;
		}
		return errorMessage;
	}
}
